export const countryCode = {
    "AFGHANISTAN": "93",
    "ALBANIA": "355",
    "ALGERIA": "213",
    "AMERICAN SAMOA": "1684",
    "ANDORRA": "376",
    "ANGOLA": "244",
    "ANGUILLA": "1264",
    "ANTARCTICA": "672",
    "ANTIGUA AND BARBUDA": "1268",
    "ARGENTINA": "54",
    "ARMENIA": "374",
    "ARUBA": "297",
    "AUSTRALIA": "61",
    "AUSTRIA": "43",
    "AZERBAIJAN": "994",
    "BAHAMAS": "1242",
    "BAHRAIN": "973",
    "BANGLADESH": "880",
    "BARBADOS": "1246",
    "BELARUS": "375",
    "BELGIUM": "32",
    "BELIZE": "501",
    "BENIN": "229",
    "BERMUDA": "1441",
    "BHUTAN": "975",
    "BOLIVIA": "591",
    "BOSNIA AND HERZEGOVINA": "387",
    "BOTSWANA": "267",
    "BRAZIL": "55",
    "BRITISH INDIAN OCEAN TERRITORY": "246",
    "BRITISH VIRGIN ISLANDS": "1284",
    "BRUNEI": "673",
    "BULGARIA": "359",
    "BURKINA FASO": "226",
    "BURUNDI": "257",
    "CAMBODIA": "855",
    "CAMEROON": "237",
    "CANADA": "1",
    "CAPE VERDE": "238",
    "CAYMAN ISLANDS": "1345",
    "CENTRAL AFRICAN REPUBLIC": "236",
    "CHAD": "235",
    "CHILE": "56",
    "CHINA": "86",
    "CHRISTMAS ISLAND": "61",
    "COCOS ISLANDS": "61",
    "COLOMBIA": "57",
    "COMOROS": "269",
    "COOK ISLANDS": "682",
    "COSTA RICA": "506",
    "CROATIA": "385",
    "CUBA": "53",
    "CURACAO": "599",
    "CYPRUS": "357",
    "CZECH REPUBLIC": "420",
    "DEMOCRATIC REPUBLIC OF THE CONGO": "243",
    "DENMARK": "45",
    "DJIBOUTI": "253",
    "DOMINICA": "1767",
    "DOMINICAN REPUBLIC": "1809",
    "EAST TIMOR": "670",
    "ECUADOR": "593",
    "EGYPT": "20",
    "EL SALVADOR": "503",
    "EQUATORIAL GUINEA": "240",
    "ERITREA": "291",
    "ESTONIA": "372",
    "ETHIOPIA": "251",
    "FALKLAND ISLANDS": "500",
    "FAROE ISLANDS": "298",
    "FIJI": "679",
    "FINLAND": "358",
    "FRANCE": "33",
    "FRENCH POLYNESIA": "689",
    "GABON": "241",
    "GAMBIA": "220",
    "GEORGIA": "995",
    "GERMANY": "49",
    "GHANA": "233",
    "GIBRALTAR": "350",
    "GREECE": "30",
    "GREENLAND": "299",
    "GRENADA": "1473",
    "GUAM": "1671",
    "GUATEMALA": "502",
    "GUERNSEY": "441481",
    "GUINEA": "224",
    "GUINEABISSAU": "245",
    "GUYANA": "592",
    "HAITI": "509",
    "HONDURAS": "504",
    "HONG KONG": "852",
    "HUNGARY": "36",
    "ICELAND": "354",
    "INDIA": "91",
    "INDONESIA": "62",
    "IRAN": "98",
    "IRAQ": "964",
    "IRELAND": "353",
    "ISLE OF MAN": "441624",
    "ISRAEL": "972",
    "ITALY": "39",
    "IVORY COAST": "225",
    "JAMAICA": "1876",
    "JAPAN": "81",
    "JERSEY": "441534",
    "JORDAN": "962",
    "KAZAKHSTAN": "7",
    "KENYA": "254",
    "KIRIBATI": "686",
    "KOSOVO": "383",
    "KUWAIT": "965",
    "KYRGYZSTAN": "996",
    "LAOS": "856",
    "LATVIA": "371",
    "LEBANON": "961",
    "LESOTHO": "266",
    "LIBERIA": "231",
    "LIBYA": "218",
    "LIECHTENSTEIN": "423",
    "LITHUANIA": "370",
    "LUXEMBOURG": "352",
    "MACAU": "853",
    "MACEDONIA": "389",
    "MADAGASCAR": "261",
    "MALAWI": "265",
    "MALAYSIA": "60",
    "MALDIVES": "960",
    "MALI": "223",
    "MALTA": "356",
    "MARSHALL ISLANDS": "692",
    "MAURITANIA": "222",
    "MAURITIUS": "230",
    "MAYOTTE": "262",
    "MEXICO": "52",
    "MICRONESIA": "691",
    "MOLDOVA": "373",
    "MONACO": "377",
    "MONGOLIA": "976",
    "MONTENEGRO": "382",
    "MONTSERRAT": "1664",
    "MOROCCO": "212",
    "MOZAMBIQUE": "258",
    "MYANMAR": "95",
    "NAMIBIA": "264",
    "NAURU": "674",
    "NEPAL": "977",
    "NETHERLANDS": "31",
    "NETHERLANDS ANTILLES": "599",
    "NEW CALEDONIA": "687",
    "NEW ZEALAND": "64",
    "NICARAGUA": "505",
    "NIGER": "227",
    "NIGERIA": "234",
    "NIUE": "683",
    "NORTH KOREA": "850",
    "NORTHERN MARIANA ISLANDS": "1670",
    "NORWAY": "47",
    "OMAN": "968",
    "PAKISTAN": "92",
    "PALAU": "680",
    "PALESTINE": "970",
    "PANAMA": "507",
    "PAPUA NEW GUINEA": "675",
    "PARAGUAY": "595",
    "PERU": "51",
    "PHILIPPINES": "63",
    "POLAND": "48",
    "PORTUGAL": "351",
    "PUERTO RICO": "1787",
    "QATAR": "974",
    "REPUBLIC OF THE CONGO": "242",
    "REUNION": "262",
    "ROMANIA": "40",
    "RUSSIA": "7",
    "RWANDA": "250",
    "SAINT BARTHELEMY": "590",
    "SAINT HELENA": "290",
    "SAINT KITTS AND NEVIS": "1869",
    "SAINT LUCIA": "1758",
    "SAINT MARTIN": "590",
    "SAINT PIERRE AND MIQUELON": "508",
    "SAINT VINCENT AND THE GRENADINES": "1784",
    "SAMOA": "685",
    "SAN MARINO": "378",
    "SAO TOME AND PRINCIPE": "239",
    "SAUDI ARABIA": "966",
    "SENEGAL": "221",
    "SERBIA": "381",
    "SEYCHELLES": "248",
    "SIERRA LEONE": "232",
    "SINGAPORE": "65",
    "SLOVAKIA": "421",
    "SLOVENIA": "386",
    "SOLOMON ISLANDS": "677",
    "SOMALIA": "252",
    "SOUTH AFRICA": "27",
    "SOUTH KOREA": "82",
    "SOUTH SUDAN": "211",
    "SPAIN": "34",
    "SRI LANKA": "94",
    "SUDAN": "249",
    "SURINAME": "597",
    "SWEDEN": "46",
    "SWITZERLAND": "41",
    "SYRIA": "963",
    "TAIWAN": "886",
    "TAJIKISTAN": "992",
    "TANZANIA": "255",
    "THAILAND": "66",
    "TOGO": "228",
    "TONGA": "676",
    "TRINIDAD AND TOBAGO": "1868",
    "TUNISIA": "216",
    "TURKEY": "90",
    "TURKMENISTAN": "993",
    "TUVALU": "688",
    "UGANDA": "256",
    "UKRAINE": "380",
    "UNITED ARAB EMIRATES": "971",
    "UK": "44",
    "USA": "1",
    "URUGUAY": "598",
    "UZBEKISTAN": "998",
    "VANUATU": "678",
    "VATICAN": "39",
    "VENEZUELA": "58",
    "VIETNAM": "84",
    "WALLIS AND FUTUNA": "681",
    "WESTERN SAHARA": "212",
    "YEMEN": "967",
    "ZAMBIA": "260",
    "ZIMBABWE": "263"
};

export const mainDocumentArr = {
    "General, Family or Social": {
      "Parent of Indonesian Citizen": {},
      "Tourism, Family Visit, and Transit": {
        "A1 - Visa Exemption Tourism": {},
        "B1 - Tourist (Visa On Arrival)": {
          "Passport Valid for At Least 6 Months":
            "For holders of travel documents other than passports such as emergency passports, documents of identity, etc. must be valid for 12 months.",
          "Return Ticket":
            "Return ticket or onward ticket to continue the journey to another country except for the crew of the Conveyance who will stop by to join the ship and continue the journey to another country.",
        },
        "C1 - Tourist Single Entry Visitor Visa - 60 Days": {
          "Personal Bank Statement With Minimum Amount USD $2000":
            "Personal bank statement with minimum amount USD $2000 or equivalent the last 3 months period (including name, date of period, and balance account)",
        },
        "D1 - Tourist Multiple Entry Visa (5 Years)": {
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "Any of the following documents": [
            "1. Information, invitations, or correspondence from government agencies or private institutions that Explain the relationship with the Applicant;",
            "2. Statement letter from the spouse or parents explaining the family relationship with the applicant and the activities to be carried out in Indonesia, attached with a family card / similar document.",
          ],
          "Support Document": {
            "Curriculum Vitae": [],
            "Travel Itinerary": ["Schedule of Activities in Indonesia"],
          },
        },
        "D1 - Tourist Multiple Entry Visa (2 Years)": {
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "Any of the following documents": [
            "1. Information, invitations, or correspondence from government agencies or private institutions that Explain the relationship with the Applicant;",
            "2. Statement letter from the spouse or parents explaining the family relationship with the applicant and the activities to be carried out in Indonesia, attached with a family card / similar document.",
          ],
          "Support Document": {
            "Curriculum Vitae": [],
            "Travel Itinerary": ["Schedule of Activities in Indonesia"],
          },
        },
        "D1 - Tourist Multiple Entry Visa (1 Year)": {
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "Any of the following documents": [
            "1. Information, invitations, or correspondence from government agencies or private institutions that Explain the relationship with the Applicant;",
            "2. Statement letter from the spouse or parents explaining the family relationship with the applicant and the activities to be carried out in Indonesia, attached with a family card / similar document.",
          ],
          "Support Document": {
            "Curriculum Vitae": [],
            "Travel Itinerary": ["Schedule of Activities in Indonesia"],
          },
        },
      },
      "Medical Treatment": {
        "A3 - Visa Exemption Medical Treatment": {},
        "B3 - Medical Treatment (Visa On Arrival)": {
          "Passport Valid for At Least 6 Months":
            "For holders of travel documents other than passports such as emergency passports, documents of identity, etc. must be valid for 12 months.",
          "Return Ticket":
            "Return ticket or onward ticket to continue the journey to another country except for the crew of the Conveyance who will stop by to join the ship and continue the journey to another country.",
        },
        "C3 - Medical Treatment": {},
        "D3 - Medical Treatment Multiple Entry Visa (2 Years)": {},
        "D3 - Medical Treatment Multiple Entry Visa (1 Year)": {},
      },
      "Social": {
        "C6 - Social, Humanitarian and Volunteering": {},
      },
      "Family Dependant": {
        "E31A - Spouse of Indonesian Citizen": {},
        "E31B - Spouse Visa": {},
        "E31C - Child of Indonesian Citizen": {},
        "E31D - Stepchild of Indonesian Citizen": {},
        "E31E - Child Visa": {},
        "E31F - A lawfully adopted child of Indonesian Citizen": {},
        "E31G - Parent of Indonesian Citizen": {},
        "E31H - Parent Visa": {},
        "E31J - Sibling": {},
      },
      "Family Dependant for Golden Visa": {
        "E31B - Spouse Visa": {
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "Proof of Guarantee Husband or Wife":
            "Proof of Guarantee from the Guarantor or a Statement of Commitment from the Husband or Wife",
          "Marriage Certificate":
            "Marriage Certificate or Marriage Book that has been Translated Into Indonesian by A Sworn Translator Except those that have been Written in English",
          "Valid Limited Stay Permit Permanent":
            "A Valid Limited Stay Permit/Permanent Stay Permit or Limited Stay Visa of the Husband or Wife",
          "Support Document": {
            "Curriculum Vitae": [],
            "Travel Itinerary": ["Schedule of Activities in Indonesia"],
          },
        },
        "E31E - Child Visa": {
          "Proof of Guarantee of His/Her Parents":
            "Proof of Guarantee from the Guarantor or Statement of Commitment of His/Her Parents",
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "Birth Certificate":
            "Birth Certificate that has been Translated Into Indonesian by A Sworn Translator, Except it is Written in English",
          "Marriage Certificate":
            "Marriage Certificate or Marriage Book that has been Translated Into Indonesian by A Sworn Translator Except those that have been Written in English",
          "Permanent Stay Permit":
            "Parents Valid Limited Stay Permit/Permanent Stay Permit or Limited Stay Visa",
          "Support Document": {
            "Proof of Medical Condition":
              "Which has been translated into Indonesian by a sworn translator, except in English.",
            "Curriculum Vitae": [],
            "Travel Itinerary": ["Schedule of Activities in Indonesia"],
          },
        },
        "E31H - Parent Visa": {
          "E31H Proof of Guarantee":
            "Proof of Guarantee From the Guarantor or Statement of Commitment of His/Her Children",
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "Birth Certificate":
            "Birth Certificate that has been Translated Into Indonesian by A Sworn Translator, Except it is Written in English ",
          "E31H Stay Permit":
            "The Children's Valid Limited Stay Permit/Permanent Stay Permit or Limited Stay Visa",
          "Support Document": {
            "Curriculum Vitae": [],
            "Travel Itinerary": ["Schedule of Activities in Indonesia"],
          },
        },
        "E31J - Sibling Visa": {
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "E31J Proof of Guarantee from the Guarantor":
            "Information, invitations, or correspondence from government agencies or private institutions explaining the relationship with the foreigner concerned",
          "Birth Certificate of Sibling":
            "Birth certificates of siblings that have been translated into Indonesian by a sworn translator, except in English",
          "E31J Stay Permit of a sibling":
            "Limited Stay Visa, Limited Stay Permit, or Permanent Stay Permit of a sibling that is still valid.",
          "Curriculum Vitae": [],
          "Travel Itinerary": ["Schedule of Activities in Indonesia"],
        },
      },
    },
    "Investment, Business, or Government": {
      "Business, Meeting, and Goods Purchasing": {
        "B2 - Business (Visa On Arrival)": {
          "Passport Valid for At Least 6 Months":
            "For holders of travel documents other than passports such as emergency passports, documents of identity, etc. must be valid for 12 months.",
          "Return Ticket":
            "Return ticket or onward ticket to continue the journey to another country except for the crew of the Conveyance who will stop by to join the ship and continue the journey to another country.",
        },
        "C2 - Business Single Entry Visa": {
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "Guarantee from the National Government Institutions":
            "(that Explain the Relevance of the Foreigner Being Invited). Information, invitations, or correspondence from government agencies or private institutions that Explain the relationship with the Applicant",
        },
        "D2 - Business Multiple Entry Visa (1 Year)": {
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "Any of the following documents": [
            "1. Information, invitations, or correspondence from government agencies or private institutions that Explain the relationship with the Applicant;",
            "2. Statement letter from the spouse or parents explaining the family relationship with the applicant and the activities to be carried out in Indonesia, attached with a family card / similar document.",
          ],
          "Support Document": {
            "Curriculum Vitae": [],
            "Travel Itinerary": ["Schedule of Activities in Indonesia"],
          },
        },
        "D2 - Business Multiple Entry Visa (5 Years)": {
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "Any of the following documents": [
            "1. Information, invitations, or correspondence from government agencies or private institutions that Explain the relationship with the Applicant;",
            "2. Statement letter from the spouse or parents explaining the family relationship with the applicant and the activities to be carried out in Indonesia, attached with a family card / similar document.",
          ],
          "Proof of Guarantee from the Guarantor":
            "Information, invitations, or correspondence from government agencies or private institutions explaining the relationship with the foreigner concerned",
          "Support Document": {
            "Curriculum Vitae": [],
            "Travel Itinerary": ["Schedule of Activities in Indonesia"],
          },
        },
        "D2 - Business Multiple Entry Visa (2 Years)": {
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "Any of the following documents": [
            "1. Information, invitations, or correspondence from government agencies or private institutions that Explain the relationship with the Applicant;",
            "2. Statement letter from the spouse or parents explaining the family relationship with the applicant and the activities to be carried out in Indonesia, attached with a family card / similar document.",
          ],
          "Support Document": {
            "Curriculum Vitae": [],
            "Travel Itinerary": ["Schedule of Activities in Indonesia"],
          },
        },
      },
      "Government Business": {
        "A4 - Visa Exemption Government Business": {},
        "B4 - Government Business (Visa On Arrival)": {
          "Passport Valid for At Least 6 Months":
            "For holders of travel documents other than passports such as emergency passports, documents of identity, etc. must be valid for 12 months",
          "Return Ticket":
            "Return ticket or onward ticket to continue the journey to another country except for the crew of the Conveyance who will stop by to join the ship and continue the journey to another country.",
        },
        "C4 - Government Business": {},
        "D4 - Government Business Multiple Entry Visa (1 Year)": {},
        "D4 - Government Business Multiple Entry Visa (2 Years)": {},
      },
      "Investment": {
        "C12 - Pre-Investment": {},
        "D12 - Pre-Investment Multiple Entry Visa (2 Years)": {
          "Proof of Living Expenses (USD$5000)":
            "Personal bank statement with minimum amount USD $5000 or equivalent the last 3 months period (including name, date of period, and balance account)",
          "Recommendations Related Agencies":
            "Information, invitations, or correspondence from government agencies or private institutions that Explain the relationship with the Applicant",
          "Support Document": {
            "Curriculum Vitae": [],
            "Travel Itinerary": ["Schedule of Activities in Indonesia"],
          },
        },
        "D12 - Pre-Investment Multiple Entry Visa (1 Year)": {
          "Proof of Living Expenses (USD$5000)":
            "Personal bank statement with minimum amount USD $5000 or equivalent the last 3 months period (including name, date of period, and balance account)",
          "Recommendations Related Agencies":
            "Information, invitations, or correspondence from government agencies or private institutions that Explain the relationship with the Applicant",
          "Support Document": {
            "Curriculum Vitae": [],
            "Travel Itinerary": ["Schedule of Activities in Indonesia"],
          },
        },
        "E28A - General Investment": {},
      },
      "Exhibitor": {
        "C11 - Exhibitor": {},
      },
      "Carry Out Audits, Production Quality Control, or Inspections at Company Branches in Indonesia":
        "",
    },
    "Golden Visa": {
      "Investment (G)": {
        "E28B - Individual Investor (Establish a Company)": {
          "Proof of Share Companies":
            "Proof of Share Ownership in Companies Outside Indonesia",
          "Proof of Turnover/Sales Financial Statements":
            "Proof of Turnover/Sales Value of the Company Contained in the Audited Financial Statements from an International Standard Public Accounting Firm",
          "Statement of Commitment Must be Fulfilled":
            "Statement of Commitment that Must be Fulfilled in Indonesia A Maximum of 90 (Ninety) Days Since Arrival",
          "Support Document": {
            "Curriculum Vitae": [],
            "Travel Itinerary": "Schedule of Activities in Indonesia",
          },
        },
        "E28C - Individual Investor (Purchase of Indonesian Government Bonds or Indonesian Company Stocks)":
          {
            "Statement of Commitment Must be Fulfilled":
              "Statement of Commitment that Must be Fulfilled in Indonesia A Maximum of 90 (Ninety) Days Since Arrival",
            "Support Document": {
              "Curriculum Vitae": [],
              "Travel Itinerary": "Schedule of Activities in Indonesia",
            },
          },
        "E28D - Corporate Investor that will Establish Branches or Subsidiaries in Indonesia":
          {
            "Proof of Turnover/Sales Financial Statements":
              "Proof of Turnover/Sales Value of the Company Contained in the Audited Financial Statements from an International Standard Public Accounting Firm",
            "Statement of Commitment Must be Fulfilled":
              "Statement of Commitment that Must be Fulfilled in Indonesia A Maximum of 90 (Ninety) Days Since Arrival",
            "Support Document": {
              "Curriculum Vitae": [],
              "Travel Itinerary": "Schedule of Activities in Indonesia",
            },
          },
        "E28F - Corporate Investor (BOD or BOC) that will Establish Branches or Subsidiaries in Nusantara Capital City (NCC)":
          {
            "Statement of Commitment Must be Fulfilled":
              "Statement of Commitment that Must be Fulfilled in Indonesia A Maximum of 90 (Ninety) Days Since Arrival",
            "Support Document": {
              "Curriculum Vitae": [],
              "Travel Itinerary": "Schedule of Activities in Indonesia",
            },
          },
        "E28G - Representative of Overseas Company": {
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "Curriculum Vitae": "",
          "Travel Itinerary": "Schedule of Activities in Indonesia",
          "Statement letter private institution":
            "Statement letter from a government agency or private institution as the host of the program that explains the foreigner's activities during in Indonesia",
        },
      },
      "Global Talent": {
        "E33A - Global Talent Invited by the Government": {},
        "E33B - Global Talent Collaborating with the Government": {
          "Statement of Commitment Must be Fulfilled":
            "Statement of Commitment that Must be Fulfilled in Indonesia A Maximum of 90 (Ninety) Days Since Arrival",
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "Evidence Which Indicates Expertise":
            "Evidence Which Indicates the Foreigner's Special Expertise",
          "Support Document": {
            "Curriculum Vitae": [],
            "Travel Itinerary": "Schedule of Activities in Indonesia",
          },
        },
      },
    },
    "Diaspora": {
      "Diaspora": {
        "E32A - Ex-Indonesian Citizen Visa": {
          "Statement of Commitment Must be Fulfilled":
            "Statement of Commitment that Must be Fulfilled in Indonesia A Maximum of 90 (Ninety) Days Since Arrival",
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "Identity Card/Family Republic of Indonesia":
            "Identity Card/ Family Card/ Birth Certificate/ Passport of the Republic of Indonesia/Diploma/ House Certificate",
          "Support Document": {
            "Curriculum Vitae": [],
            "Travel Itinerary": "Schedule of Activities in Indonesia",
          },
        },
        "E32B - Descendant of an Ex-Indonesia Citizen": {
          "Statement of Commitment Must be Fulfilled":
            "Statement of Commitment that Must be Fulfilled in Indonesia A Maximum of 90 (Ninety) Days Since Arrival",
          "Birth Certificate/Family":
            "Birth Certificate/Family Card/Marriage Certificate",
          "Support Document": {
            "Curriculum Vitae": "",
            "Travel Itinerary": "Schedule of Activities in Indonesia",
          },
        },
      },
    },
    "Silver Hair": {
      "Silver Hair": {
        "E33E - Silver Hair Visa": {
          "Statement of Commitment Must be Fulfilled":
            "Statement of Commitment that Must be Fulfilled in Indonesia A Maximum of 90 (Ninety) Days Since Arrival",
          "Proof of Income or Benefits": [],
          "Support Document": {
            "Curriculum Vitae": [],
            "Travel Itinerary": "Schedule of Activities in Indonesia",
          },
        },
      },
    },
    "Second Home": {
      "Second Home": {
        "E33 - Second Home Visa": {
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "Statement of Commitment Must be Fulfilled":
            "Statement of Commitment that Must be Fulfilled in Indonesia A Maximum of 90 (Ninety) Days Since Arrival",
          "Support Document": {
            "Curriculum Vitae": [""],
            "Travel Itinerary": ["Schedule of Activities in Indonesia"],
          },
        },
      },
      "Family Dependant for Secondhome Visa": {
        "E31B - Spouse Visa": {
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "Proof of Guarantee Husband or Wife":
            "Proof of Guarantee from the Guarantor or a Statement of Commitment from the Husband or Wife",
          "Marriage Certificate":
            "Marriage Certificate or Marriage Book that has been Translated Into Indonesian by A Sworn Translator Except those that have been Written in English",
          "Valid Limited Stay Permit Permanent":
            "A Valid Limited Stay Permit/Permanent Stay Permit or Limited Stay Visa of the Husband or Wife",
          "Support Document": {
            "Curriculum Vitae": [""],
            "Travel Itinerary": ["Schedule of Activities in Indonesia"],
          },
        },
        "E31E - Child Visa": {
          "Proof of Guarantee of His/Her Parents":
            "Proof of Guarantee from the Guarantor or Statement of Commitment of His/Her Parents",
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "Birth Certificate":
            "Birth Certificate that has been Translated Into Indonesian by A Sworn Translator, Except it is Written in English",
          "Marriage Certificate":
            "Marriage Certificate or Marriage Book that has been Translated Into Indonesian by A Sworn Translator Except those that have been Written in English",
          "Permanent Stay Permit":
            "Parents Valid Limited Stay Permit/Permanent Stay Permit or Limited Stay Visa",
          "Support Document": {
            "Proof of Medical Condition":
              "Proof of Medical Condition or Evidence",
            "Curriculum Vitae": [""],
            "Travel Itinerary": ["Schedule of Activities in Indonesia"],
          },
        },
        "E31H - Parent Visa": {
          "E31H Proof of Guarantee":
            "Proof of Guarantee From the Guarantor or Statement of Commitment of His/Her Children",
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "Birth Certificate":
            "Birth Certificate that has been Translated Into Indonesian by A Sworn Translator, Except it is Written in English",
          "E31H Stay Permit":
            "The Children's Valid Limited Stay Permit/Permanent Stay Permit or Limited Stay Visa",
          "Support Document": {
            "Curriculum Vitae": [""],
            "Travel Itinerary": ["Schedule of Activities in Indonesia"],
          },
        },
        "E31J - Sibling for Second home visa or stay permit holder": {
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "E31J Proof of Guarantee from the Guarantor":
            "Information, invitations, or correspondence from government agencies or private institutions explaining the relationship with the foreigner concerned",
          "Birth Certificate of Sibling":
            "Birth certificates of siblings that have been translated into Indonesian by a sworn translator, except in English",
          "E31J Stay Permit of a sibling":
            "Limited Stay Visa, Limited Stay Permit, or Permanent Stay Permit of a sibling that is still valid.",
          "Curriculum Vitae": [""],
          "Travel Itinerary": ["Schedule of Activities in Indonesia"],
        },
      },
    },
    "Professional or Employment": {
      "Employment": {
        "E23": [],
        "E23B": [],
        "E23C": [],
        "E23D": [],
        "E23E": [],
        "E23F": [],
        "E23G": [],
        "E23H": [],
        "E23I": [],
        "E23J": [],
        "E23K": [],
        "E23L": [],
        "E23M": [],
        "E23N": [],
        "E23O": [],
        "E23P": [],
        "E23Q": [],
        "E23R": [],
        "E23S": [],
        "E23T": [],
        "E23U": [],
        "E23V": [],
        "E23W": [],
        "E24": [],
        "E24A": [],
        "E24B": [],
        "E24C": [],
        "E24D": [],
        "E24E": [],
        "E24F": [],
        "E25": [],
        "E25A": [],
        "E25B": [],
        "E25C": [],
        "E25D": [],
        "E25E": [],
        "E25F": [],
        "E26": [],
        "E27": [],
      },
      "Professional": {
        "C10A": [],
        "C15": [],
        "C16": [],
        "C17": [],
        "C18": [],
        "C19": [],
        "C20": [],
        "D17": [],
        "D17_1": [],
        "E33G": {
          "Personal Bank Statement With Minimum Amount USD $2000":
            "Personal bank statement with minimum amount USD $2000 or equivalent the last 3 months period (including name, date of period, and balance account)",
          "Bank account salary or income":
            "Bank account that proves income in the form of salary or income worth at least US$60,000 per year",
          "Employment contract":
            "Employment contract with a company established outside the Indonesian Territory.",
          "Support Document": {
            "Curriculum Vitae": [],
            "Travel Itinerary": "Schedule of Activities in Indonesia",
          },
        },
      },
      "Invited Event Participants": {
        "C10": [],
      },
    },
    "Journalist or Film": {
      "Journalist": {
        "C5": {
          "Personal Bank Statement":
            "Personal bank statement at last 3 months period (including name, date of period, and balance account)",
          "Invitations or information from government":
            "(institutions/interview transcript that has been approved by the resource person/a statement from the Indonesian Embassy) Regarding news coverage plans in Indonesia, including a press ID.",
        },
      },
      "Filming": {
        "C14": [],
        "D14": [],
      },
    },
    "Sport or Performer": {
      "Performer": {
        "C7": [],
        "C7A": [],
        "C7B": [],
        "D7": [],
        "D7A": [],
        "D7B": [],
      },
      "Sport": {
        "C8A": [],
        "C8B": [],
        "D8A": [],
        "D8B": [],
      },
    },
    "Study, Courses, Training or Research": {
      "Research": {
        "E29": [],
      },
      "Comparative Study, Short Courses and Short Training": {
        "C9": [],
        "C9A": [],
        "C9B": [],
      },
      "Study": {
        "E30A": [],
        "E30B": [],
      },
      "Internship": {
        "C22A": [],
        "C22B": [],
      },
    },
    "Miscellaneous": {
      "Miscellaneous": {
        "C13": [],
        "C21": [],
        "E33F": [],
        "E35A": [],
      },
    },
  };